<div class="fix-width bg-white flex column radius padding margin-top-largest shadow">
  <div class="flex center margin-bottom">
    <img src="https://basicplatformblob.blob.core.windows.net/resources/LOGOS/BASICNET.PNG" />
  </div>

  @if (noCompanyAvailable) {
    <div class="flex column center border padding margin-bottom-smallest">
      <i class="fa-solid fa-circle-exclamation icon-big grey margin-bottom-smallest"></i>
      <h1 class="margin-bottom-smallest grey">No company available</h1>
      <span class="grey">This browsing profile is not enabled on BasicStudios.</span>
    </div>

    <div class="flex center margin-top-smallest">
      <small class="grey">Switch to a browsing profile enabled here, or ask the administrator to enable this one.</small>
    </div>

    <div class="flex column end margin-top">
      <button (click)="changeProfile()">
        <i class="fa-solid fa-user-group margin-right-small"></i>
        Change browsing profile
      </button>
    </div>
  } @else {
    <div class="margin-bottom-small">
      Please select your
      <b>Company</b>
      :
    </div>

    <div class="flex column margin-top-smallest">
      <div class="flex column scrollable border bg-light-grey company-list-box">
        @if (companyFilterService.loading && !datasource.length) {
          <div class="flex center padding">
            <i class="fa-solid fa-circle-notch fa-spin"></i>
          </div>
        } @else {
          @for (company of datasource; track company.displayId) {
            <div
              class="padding-small hover"
              [ngClass]="company.selected ? 'bg-primary white' : ''"
              (click)="onClickCompany(company)"
            >
              <i class="fa fa-arrow-right margin-right-smallest"></i>
              {{ company.displayName }}
            </div>
          }
        }
      </div>
    </div>

    <div class="flex column end margin-top">
      <button (click)="companySelection()" [disabled]="!selectedCompany.length">
        <i class="fa fa-check margin-right-small"></i>
        Confirm
      </button>
    </div>
  }
</div>
